import store from '../store.js';

export default {
    computed: {
        $_user: () => {
            return store.state.user;
        },
        $_userCanPostOffers: () => {
            return store.state.user.can_post_offers
        },
        $_userCanAcceptOffers: () => {
            return store.state.user.can_accept_offers;
        }
    },
}
